import { Component, ViewChild, OnInit, OnDestroy, Input, NgModule } from "@angular/core";
import { PrintComponent, PrintComponentModule } from "../../../blocks/print-component/print-component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserSessionService, StockParms, StockModuleSettingsParms, SharedModule } from "../../../shared";
import { StepperComponent } from "../../../blocks";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ExaminationSupplyService } from "../../examination-supply/examination-supply.service";
import { GenStockTransService } from "../../../stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/gen-stock-trans-exchange-outpatient.service";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
// import { CKEditorModule } from "ng2-ckeditor";
import { BlocksModule } from "../../../blocks/blocks.module";
import { MailComponent } from "../../../blocks/mail/mail/mail.component";
import { MailService } from "../../../blocks/mail/mail/mail.service";
import { OffersNeedPrintComponent } from "../../offers-needed/offers-needed-print/offers-needed-print.component";
@Component({
  selector: "po-order-supply-print",
  templateUrl: "./po-order-supply-print.component.html"
})
export class PoOrderSupplyPrintComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  items = [];
  private unsubscribe = new Subject();
  defaultBranchLogoPath: string = "../../../../assets/images/ora/1.png"
  row: any = <any>{};
  totals: any = <any>{};
  StrOfferPrice: any = <any>{};
  poOrderSupplySerial = [];
  allowReset: number;
  @ViewChild("printComponent")
  printComponent: PrintComponent;
  @Input() myStepNumber: number;
  @Input() PoOrderFlageForPrint: any;
  patientFlag: any;
  @Input() stepperComponent: StepperComponent;
  stockSettingsParms: StockModuleSettingsParms = {};
  FormOfPoOrderSupplyPrint: number;
  stockSetting: {};
  UpdateItemPricePer: number;
  updateItemCostPrice: number;
  addTaxToUnitCost: number;

  constructor(
    private _ExaminationSupplyService: ExaminationSupplyService,
    public translate: TranslateService,
    private _DirectAddTransService: GenStockTransService,
    private _userSessionService: UserSessionService
  ) { }

  ngOnInit() {
    this.getModuleSettings();
    this._userSessionService.subscribeToKey$('PoOrderMasterTransSerial')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.getGetpoOrderSupplyResetInfo(keys.value);
        }
      });

    this._userSessionService.subscribeToKey$('PoOrderResetPrint')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.reset();;;;;
        }
      });
    this._userSessionService.subscribeToKey$('SecLoginPrivileges').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {

          if (keys.value[0]['updateItemPrice'] == 1) {
            this.UpdateItemPricePer = 1;
          }
          else if (keys.value[0]['updateItemPrice'] != 1) {
            this.UpdateItemPricePer = 0;
          }

          if (keys.value[0]['updateItemCostPrice'] == 1) {
            this.updateItemCostPrice = 1;
          }
          else if (keys.value[0]['updateItemCostPrice'] != 1) {
            this.updateItemCostPrice = 0;
          }
        }
      });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  reset() {
    this.row = {};
    this.items = [];
    this.StrOfferPrice = []
  }

  poOrderType: number;
  getGetpoOrderSupplyResetInfo(PoOrderSupCode) {
    var hgh = <any>this._userSessionService.getSessionKey("IFASSETS");
    var notes = "";
    var queryCode: number;
    if (hgh && hgh["poOrderType"] == 3) {
      notes = 'Assets'//hgh["notes"];
      queryCode = 7//hgh["queryCode"];
      this.poOrderType = 3//hgh["poOrderType"]; 
    }
    else {
      queryCode = 6
    }
    if (PoOrderSupCode != undefined || PoOrderSupCode != null) {
      var prem: StockParms = {
        serial: PoOrderSupCode,
        notes: notes,
        queryCode: queryCode
      };
      this.row = <any>{};
      this.StrOfferPrice = []
      this.items = [];
      this.StrOfferPrice = []
      this._ExaminationSupplyService
        .getPoOrderSupply(prem, notes)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          r => {
            if (r) {
              var hgh = <any>this._userSessionService.getSessionKey("IFASSETS");
              if (hgh && hgh["poOrderType"] == 3) {
                if (r.data && r.data.length > 0) {
                  this.row = r.data[0];
                  this.items = r.data;
                  this.totals = r.data[0];
                }
              }
              else {
                if (r.data && r.data.length > 0) {
                  this.row = r.data[0];
                }
                if (r.data1 && r.data1.length > 0) {
                  this.items = r.data1;
                }
                if (r.data2 && r.data2.length > 0) {
                  this.totals = r.data2[0];
                }
                if (r.data3 && r.data3.length > 0) {
                  this.StrOfferPrice = r.data3;
                }
              }

              setTimeout(() => {
                if (this.printComponent) {
                  this.printComponent.PrintView();
                }
              }, 200);
            }
          },
          error => console.log(error),
          () => null
        );
    }
  }
  htmlcontent
  getPrintHtml() {
    const HtmlPrint = document.getElementById('section');
    this.htmlcontent = HtmlPrint.innerHTML;
    console.log(HtmlPrint);
  }

  getModuleSettings() {
    this._userSessionService.subscribeToKey$('link')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(link => {
        if (link.name = 'link') {
          this.stockSettingsParms.moduleId = link.value.parentCode;
          this._userSessionService.subscribeToKey$('modulesSettings')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
              if (keys.value) {
                this.stockSetting = keys.value[`m_${this.stockSettingsParms.moduleId}`];
                this.FormOfPoOrderSupplyPrint = this.stockSetting['formOfPoOrderSupplyPrint'];
                this.addTaxToUnitCost = this.stockSetting['addTaxToUnitCost'];
              }
            });
        }
      });
    if (!this.stockSetting || !this.FormOfPoOrderSupplyPrint) {
      this._DirectAddTransService.getStockModuleSettings(this.stockSettingsParms)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c.data && c.data.length > 0) {
            this.stockSetting = c.data[0];
            if (this.stockSetting) {
              this.FormOfPoOrderSupplyPrint = this.stockSetting['formOfPoOrderSupplyPrint'];
              this.addTaxToUnitCost = this.stockSetting['addTaxToUnitCost'];
            }
          }
        });
    }
  }
}




@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        BlocksModule,
        PrintComponentModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        // CKEditorModule,
    ],
    declarations: [
        PoOrderSupplyPrintComponent,
        OffersNeedPrintComponent
    ],
    exports: [
        PoOrderSupplyPrintComponent,
        OffersNeedPrintComponent
    ], providers: [
        PoOrderSupplyPrintComponent,
        OffersNeedPrintComponent
    ]
})

export class PoOrderSupplyPrintModule { }

